import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from './styles';
import { KEY_LABELS, LABELS } from './constants';

const ReportTitle = () => {
  return (
    <View style={styles.reportTitleContainer}>
      <Text style={styles.reportTitleText}>
        {intl.get(KEY_LABELS[LABELS.TITLE])}
      </Text>
    </View>
  );
};

export default ReportTitle;
